import { render } from "@/components/pages/realWorldData/RealWorldDataTable.html?vue&type=template&id=acbcb312&external"
import script from "@/components/pages/realWorldData/RealWorldDataTable.js?vue&type=script&lang=js&external"
export * from "@/components/pages/realWorldData/RealWorldDataTable.js?vue&type=script&lang=js&external"

import "@/components/pages/realWorldData/RealWorldDataTable.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__